import React, { useState } from "react";
import {
  Step,
  StepContent,
  StepLabel,
  Stepper,
  styled,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import ClickableBadgeVisual from "../visuals/ClickableBadgeVisual";

export interface SchedulerProps {
  options: {
    label: string;
    value: string;
    items: { id: number; time: string; details: string }[];
  }[];
}
const ColorlibStepIconRoot = styled("div")(() => ({
  backgroundColor: "#B1D238",
  zIndex: 0,
  color: "#fff",
  width: 12,
  height: 12,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
}));
const Container = styled(Stack)(() => ({
  width: "26px",
  height: "24px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "35px",
  backgroundColor: " rgba(177, 210, 56, 0.2)",
}));

const Scheduler = ({ options }: SchedulerProps) => {
  const [value, setValue] = useState("Day 1");

  let content = options.find((i) => i.value === value)?.items;

  const handleAction = (value: any) => {
    setValue(value);
  };

  const ColorlibStepIcon = () => {
    return (
      <Container>
        <ColorlibStepIconRoot></ColorlibStepIconRoot>
      </Container>
    );
  };

  const Briefing = (steps: any) => {
    return (
      <Stepper orientation="vertical">
        {steps &&
          steps.steps.map((step: any) => (
            <Step key={step.id} active={true}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                <Typography variant="h4" fontWeight={500}> {step.time}</Typography>
              </StepLabel>
              <StepContent>
                <Typography variant="h4" fontWeight={400} className="font-grey">{step.details}</Typography>
              </StepContent>
            </Step>
          ))}
      </Stepper>
    );
  };

  return (
    <Stack>
      <Stack spacing={1.5} direction="row" pb={2}>
        {options &&
          options.map((item) => {
            return (
              <ClickableBadgeVisual
                label={item.label}
                onClick={() => handleAction(item.label)}
                isSelected={item.label === value}
              />
            );
          })}
      </Stack>
      <Briefing steps={content} />
    </Stack>
  );
};
export default Scheduler;
